import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {
  validatePassword,
  validateEmail
} from '../../../utils/validators';
import {Link} from 'react-router-dom'
import messages from '../../../constants/messages'
import {isAdmin, isSpruceAdmin} from '../../../utils/roles';
import Card from '../../shared/Card';
import InfoField from '../../shared/InfoField';
import InfoInputField from '../../shared/LabeledTextInput';
import UserRoleDropdown from '../../shared/UserRoleDropdown';
import PasswordInput from '../../shared/PasswordInput';
import CompanyDropdown from '../../shared/CompanyDropdown';
import styles from './styles.scss';
import {connect} from "react-redux";


const propTypes = {
  companyName: PropTypes.string,
  companyId:  PropTypes.string,
  email: PropTypes.string,
  userType: PropTypes.string,
  password: PropTypes.string,
  confirmPassword: PropTypes.string,
  passwordRequired: PropTypes.bool,
  editCompany: PropTypes.bool,
  editEmail: PropTypes.bool,
  editRole: PropTypes.bool,
  companyUser: PropTypes.bool,
  newUser: PropTypes.bool,
  onFieldChange: PropTypes.func,
  onFieldValidate: PropTypes.func,
  errors: PropTypes.object,
  showErrors: PropTypes.bool,
  userRole: PropTypes.string,
  autocompleteFields: PropTypes.func,
  hasActiveCompanyAdmin: PropTypes.bool,
};

class UserLoginInfo extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onPasswordChange = this.onPasswordChange.bind(this);
    this.onConfirmPasswordChange = this.onConfirmPasswordChange.bind(this);
    this.isConfirmPasswordValid = this.isConfirmPasswordValid.bind(this);
  }

  onPasswordChange(event) {
    const value = event.target.value;
    this.props.onFieldChange('password', value);
    this.props.onFieldChange('confirmPassword', '');
  }

  onConfirmPasswordChange(event) {
    this.props.onFieldChange('confirmPassword', event.target.value);
  }

  isConfirmPasswordValid(confirmPassword) {
    const { password } = this.props;
    return confirmPassword === password;
  }

  render() {
    const {
      companyName,
      companyId,
      email,
      userType,
      userRole,
      password,
      confirmPassword,
      passwordRequired,
      editCompany,
      editEmail,
      editRole,
      newUser,
      companyUser,
      onFieldChange,
      onFieldValidate,
      errors,
      showErrors,
      autocompleteFields,
      hasActiveCompanyAdmin,
    } = this.props;

    return (
      <Card header='User Login Information'>
        <Container className='px-0'>
          <Row className='text-left'>
            <Col md={6} className='mb-3'>
              <InfoInputField
                editMode={editEmail}
                value={email}
                label={`Username/Email ${editEmail ? '*' : ''}`}
                allowBlank={false}
                validator={validateEmail}
                validationError={messages.validation.emailInvalid}
                error={errors.email}
                invalid={(showErrors || email) && errors.email}
                onChange={value => onFieldChange('email', value)}
                onValidate={value => onFieldValidate('email', value)}
              />
            </Col>
            <Col md={6} className='mb-3'>
              <InfoField
                editMode={editRole && (newUser || !isSpruceAdmin(userType))}
                value={userType}
                label={`User Type ${editRole ? '*' : ''}`}
              >
                  <UserRoleDropdown
                    onlyCompany={companyUser}
                    value={userType}
                    hasActiveCompanyAdmin={!companyId || hasActiveCompanyAdmin}
                    onChange={(value) => {
                      onFieldChange('role', value);
                      if (isSpruceAdmin(value)) {
                        onFieldValidate('company');
                      }
                    }}
                  />
              </InfoField>
            </Col>
          </Row>
          <Row className='text-left'>
            <If condition={!isSpruceAdmin(userType)}>
              <Col md={6} className='mb-3'>
                <label className={`d-block ${styles.label}`}>{`Company Name ${editCompany ? '*' : ''}`}</label>
                <If condition={editCompany}>
                  <CompanyDropdown
                    value={companyId}
                    error={errors.company}
                    invalid={showErrors && errors.company}
                    allowBlank={isSpruceAdmin(userType)}
                    onChange={({ label, value }) => {
                      autocompleteFields(value);
                      onFieldChange('companyName', label);
                      onFieldChange('companyId', value);
                    }}
                    onValidate={value => onFieldValidate('company', value)}
                  />
                </If>
                <If condition={isSpruceAdmin(userRole) && !editCompany}>
                  <Link
                    className={`${styles.companyLink}`}
                    to={{
                      pathname:`/companies/${companyId}`,
                      state: { editMode: true }
                    }}
                  >
                    {companyName}
                  </Link>
                </If>
                <If condition={!isSpruceAdmin(userRole) && isAdmin(userRole) && !editCompany}>
                  <Link
                    className={`${styles.companyLink}`}
                    to={{
                      pathname:`/mycompany`,
                      state: { editMode: true }
                    }}
                  >
                    {companyName}
                  </Link>
                </If>
                <If condition={!isAdmin(userRole) && !editCompany}>
                  <label className={`d-block ${styles.label}`}>{companyName}</label>
                </If>
              </Col>
            </If>
          </Row>
          <Row className='text-left'>
            <Col md={6} className='mb-3'>
              <InfoField
                editMode={true}
                label={`${passwordRequired ? 'Password *' : 'New Password'}`}
               >
                <PasswordInput
                  value={password}
                  onChange={this.onPasswordChange}
                  allowBlank={!passwordRequired}
                  validator={validatePassword}
                  validationError={messages.validation.password}
                  error={errors.password}
                  invalid={Boolean((showErrors || password) && errors.password)}
                  onValidate={value => onFieldValidate('password', value)}
                />
              </InfoField>
            </Col>
            <Col md={6} className='mb-3'>
              <InfoField
                editMode={true}
                label='Confirm Password'
               >
                <PasswordInput
                  value={confirmPassword}
                  disabled={!password}
                  onChange={this.onConfirmPasswordChange}
                  validator={this.isConfirmPasswordValid}
                  validationError={messages.validation.confirmPassword}
                  onValidate={value => onFieldValidate('confirmPassword', value)}
                  error={errors.confirmPassword}
                  invalid={Boolean(errors.confirmPassword)}
                  allowBlank={!this.props.password}
                />
              </InfoField>
            </Col>
          </Row>
        </Container>
      </Card>
    );
  }
}

UserLoginInfo.propTypes = propTypes;


const mapStateToProps = ({ profile }) => ({
  userRole: profile.role
});

export default connect(mapStateToProps)(UserLoginInfo);



// WEBPACK FOOTER //
// src/components/profile/UserLoginInfo/index.jsx